import { z } from "src/lib";
import { OperacionAFOCLFields, OperacionAFOCLTablaValorFields, OperacionAFOCLTablaValorHistoricoFields } from "./fields";
import { schemaEntityWithId } from "src/types";
import { schemaStringObligatorio, schemaStringOpcional } from "src/pages/sistema/types/types";

export const schemaOperacionAFOCLTablaValorInsert = z.object({
    [OperacionAFOCLTablaValorFields.IdOperacionAFOCL]: z.number().nullable().optional(),
    [OperacionAFOCLTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOCLTablaValorFields.CodOperacionTipo]: z.number(),

    [OperacionAFOCLTablaValorFields.ValorPuente]: z.string({ 
            invalid_type_error: 'El aforo es requerido',
            required_error: 'El aforo es requerido'
        }).nullable(),
    [OperacionAFOCLTablaValorFields.ValorCliente]: z.string({ 
            invalid_type_error: 'El aforo es requerido',
            required_error: 'El aforo es requerido'
        }).nullable(),
});
export type OperacionAFOCLTablaValorInsert = z.infer<typeof schemaOperacionAFOCLTablaValorInsert>;

export const schemaOperacionAFOCLInsert = z.object({
    [OperacionAFOCLFields.CodPais]: z.number(),
    [OperacionAFOCLFields.CodUnidadNegocio]: z.number().nullable(),
    [OperacionAFOCLFields.CodSectorComercial]: z.number(),
    [OperacionAFOCLFields.NumeroCuenta]: schemaStringObligatorio,
    [OperacionAFOCLFields.RazonSocial]: schemaStringObligatorio,
    [OperacionAFOCLFields.FechaSolicitud]: z.date(),
    [OperacionAFOCLFields.FechaVencimiento]: z.date(),
    [OperacionAFOCLFields.Observaciones]: z.string().nullable().optional(),
    [OperacionAFOCLFields.TablaValores]: z.array(schemaOperacionAFOCLTablaValorInsert),
});
export type OperacionAFOCLInsert = z.infer<typeof schemaOperacionAFOCLInsert>;

export const schemaOperacionAFOCLTablaValorUpdate = z.object({
    [OperacionAFOCLTablaValorFields.ValorPuente]: z.string({
        required_error: 'El aforo es requerido.',
    }),
    [OperacionAFOCLTablaValorFields.ValorCliente]: z.string({ 
            invalid_type_error: 'El aforo es requerido',
            required_error: 'El aforo es requerido'
        }).nullable(),
});
export type OperacionAFOCLTablaValorUpdate = z.infer<typeof schemaOperacionAFOCLTablaValorUpdate>;

export const schemaOperacionAFOCLTablaValorVista = z.object({
    [OperacionAFOCLTablaValorFields.IdOperacionAFOCL]: z.number(),
    [OperacionAFOCLTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOCLTablaValorFields.DescInstrumento]: z.string(),
    [OperacionAFOCLTablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionAFOCLTablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionAFOCLTablaValorFields.ValorPuente]: z.string(),
    [OperacionAFOCLTablaValorFields.ValorCliente]: z.string(),
    [OperacionAFOCLTablaValorFields.OrdenInstrumento]: z.number(),
    [OperacionAFOCLTablaValorFields.OrdenOperacionTipo]: z.number(),
    [OperacionAFOCLTablaValorFields.PermiteEditar]: z.boolean(),
}).merge(schemaEntityWithId);
export type OperacionAFOCLTablaValorVista = z.infer<typeof schemaOperacionAFOCLTablaValorVista>;


export const schemaOperacionAFOCLTablaValorVistaInicial = z.object({
    [OperacionAFOCLTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOCLTablaValorFields.DescInstrumento]: z.string(),
    [OperacionAFOCLTablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionAFOCLTablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionAFOCLTablaValorFields.ValorPuente]: z.string(),
    [OperacionAFOCLTablaValorFields.ValorCliente]: z.string().nullable(),
    [OperacionAFOCLTablaValorFields.OrdenInstrumento]: z.number().nullable(),
    [OperacionAFOCLTablaValorFields.OrdenOperacionTipo]: z.number().nullable(),
    [OperacionAFOCLTablaValorFields.PermiteEditar]: z.boolean(),
});
export type OperacionAFOCLTablaValorVistaInicial = z.infer<typeof schemaOperacionAFOCLTablaValorVistaInicial>;


export const schemaFormUpdateTablaValores = z.object({
    [OperacionAFOCLFields.Observaciones]: schemaStringOpcional,
    [OperacionAFOCLFields.TablaValores]: z.array(schemaOperacionAFOCLTablaValorVista),
});

export type FormUpdateTablaValores = z.infer<typeof schemaFormUpdateTablaValores>;


export const schemaOperacionAFOCLTablaValorHistorico = schemaOperacionAFOCLTablaValorVista.extend({
    [OperacionAFOCLTablaValorHistoricoFields.FechaModificacion]: z.coerce.date(),
    [OperacionAFOCLTablaValorHistoricoFields.IdUsuarioModificacion]: z.number(),
    [OperacionAFOCLTablaValorHistoricoFields.NombreUsuarioModificacion]: z.string(),
    [OperacionAFOCLTablaValorHistoricoFields.Observaciones]: z.string().nullable().optional(),
});

export type OperacionAFOCLTablaValorHistorico = z.infer<typeof schemaOperacionAFOCLTablaValorHistorico>;


export const schemaOperacionAFOCLTablaValorHistoricoGrupo = z.object({
    [OperacionAFOCLTablaValorHistoricoFields.FechaModificacion]: z.coerce.date(),
    [OperacionAFOCLTablaValorHistoricoFields.NombreUsuarioModificacion]: z.string(),
    [OperacionAFOCLTablaValorHistoricoFields.Observaciones]: z.string().nullable().optional(),
    [OperacionAFOCLTablaValorHistoricoFields.Celdas]: z.array(schemaOperacionAFOCLTablaValorHistorico)
});

export type OperacionAFOCLTablaValorHistoricoGrupo = z.infer<typeof schemaOperacionAFOCLTablaValorHistoricoGrupo>;